/*
 * Author: Roger
 * File Created: Friday, 24-09-13 02:04 pm
 * Last Modified: Monday, 25-03-17 03:20 pm, by Harper Yan
 */

import { useTranslation } from 'next-i18next';

import { motion } from 'framer-motion';

import {
  Box,
  Grid,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';
import { Flex } from '@ucard/ds/containers';

import SectionBox from '@/components/LandingContainer/SectionBox';
import { staticImgPrefix } from '@/utils/prefix';

import LandingIcon from '../Icons';
import {
  IconBox,
  MoreImageBox,
  MoreInfoBox,
  PaymentTitle,
  ProductImage,
} from './style';

const Payments = () => {
  const { t } = useTranslation('home');

  return (
    <SectionBox
      layerSx={{
        background: '#212121',
        position: 'relative',
        py: ['60px', '140px'],
      }}>
      <motion.div
        initial={{ opacity: 0 }}
        style={{ textAlign: 'center' }}
        transition={{ duration: 1 }}
        whileInView={{ opacity: 1 }}>
        <PaymentTitle mb={[0, '60px']}>{t('payments.title.0')}</PaymentTitle>
        <PaymentTitle mb={[0, '60px']}>{t('payments.title.1')}</PaymentTitle>
      </motion.div>
      <Flex
        flexDirection={['column-reverse', 'row']}
        gap={[0, 4]}
        mb={['60px', '100px']}
        mt={[0, '60px']}>
        <MoreInfoBox>
          <Typography variant="h5">{t('payments.more-info.title')}</Typography>
          <List>
            <ListItem>
              <ListItemText>{t('payments.more-info.list.0')}</ListItemText>
            </ListItem>
            <ListItem>
              <ListItemText>{t('payments.more-info.list.1')}</ListItemText>
            </ListItem>
            <ListItem>
              <ListItemText>{t('payments.more-info.list.2')}</ListItemText>
            </ListItem>
          </List>
        </MoreInfoBox>
        <MoreImageBox>
          <ProductImage
            alt="decard"
            height={484}
            sizes="100vw"
            src={staticImgPrefix('/home/home-5-v2.webp')}
            width={584}
          />
        </MoreImageBox>
      </Flex>
      <Flex
        alignItems="stretch"
        flexDirection={['column', 'row']}
        gap={[2.5, 4]}>
        <IconBox>
          <LandingIcon name="Country" />
          <Box sx={{ height: '100%' }}>
            <Typography variant="h5">
              {t('payments.more-info.subjects.0.title')}
            </Typography>
            <List>
              <ListItem>
                <ListItemText>
                  {t('payments.more-info.subjects.0.list.0')}
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemText>
                  {t('payments.more-info.subjects.0.list.1')}
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemText>
                  {t('payments.more-info.subjects.0.list.2')}
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemText>
                  {t('payments.more-info.subjects.0.list.3')}
                </ListItemText>
              </ListItem>
            </List>
          </Box>
        </IconBox>
        <IconBox>
          <LandingIcon name="Earn" />
          <Box sx={{ height: '100%' }}>
            <Typography variant="h5">
              {t('payments.more-info.subjects.1.title')}
            </Typography>
            <List>
              <ListItem>
                <ListItemText>
                  {t('payments.more-info.subjects.1.list.0')}
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemText>
                  {t('payments.more-info.subjects.1.list.1')}
                </ListItemText>
              </ListItem>
            </List>
          </Box>
        </IconBox>
      </Flex>
    </SectionBox>
  );
};

export default Payments;
